import { render } from "./Ingresos.vue?vue&type=template&id=c8dceade&scoped=true"
import script from "./Ingresos.vue?vue&type=script&lang=js"
export * from "./Ingresos.vue?vue&type=script&lang=js"

import "./Ingresos.vue?vue&type=style&index=0&id=c8dceade&scoped=true&lang=css"

import exportComponent from "../../node_modules/@vue/cli-service/node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-c8dceade"]])

export default __exports__